var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","color":"primary"}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":"","color":"primary"}},[_c('v-card-text',{staticClass:"py-2 white--text text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("DEDCA")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }